import { render, staticRenderFns } from "./PriceTier.vue?vue&type=template&id=367fc86b&scoped=true&lang=pug&"
import script from "./PriceTier.vue?vue&type=script&lang=js&"
export * from "./PriceTier.vue?vue&type=script&lang=js&"
import style0 from "./PriceTier.vue?vue&type=style&index=0&id=367fc86b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367fc86b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VMenu,VRow})
